<template>
    <aside id="content-aside" class="section content-aside">
        <h2>News</h2>
        <article class="events">
            <h3>Events</h3>
            <ul>
              <!--<li><strong>30 September 2021</strong><p><router-link to="/events#event-sep-30-2021">more...</router-link></p></li>-->
              <li><strong>8–10 July 2022</strong><p>Session at the conference Musical and Theatrical Migrations: Performance Practice in 17th and 18th-Century Europe <router-link to="/events#event-jul-8-2022">more...</router-link></p></li>
              <li><strong>4–7 May 2022</strong><p>Papers at the conference ‚Parole del Metastasio‘: Opera and Emotions in Eighteenth-Century Europe in Madrid <router-link to="/events#event-may-4-2022">more...</router-link></p></li>
              <li><strong>13-14 May 2021</strong><p>University of Warsaw: digital conference <i>Operatic Pasticcio in Eighteenth-Century Europe: Work Concept, Performance Practice, Digital Humanities </i> <router-link to="/events#event-may-13-2021">more...</router-link></p></li>
              <li><strong>17 July 2021</strong><p>Round Table "Between Intermediality, Networks and Cultural Transfer: The Operatic Pasticcio <router-link to="/events#event-jul-17-2021">more...</router-link></p></li>
              <li><strong>28 September – 1 October 2021</strong><p>Roundtable at the 17th International Congress of the German Musicological Society (GfM) <router-link to="/events#event-sep-28-2021">more...</router-link></p></li>
              <li><strong>30 September 2021</strong><p>Session „Between Intermediality, Networks and Cultural Transfer: The Operatic Pasticcio” <router-link to="/events#event-sep-30-2021">more...</router-link></p></li>
              <li><strong>4–5 October 2021</strong><p>Paper at the international conference L’ultimo Atto nell’opera del Settecento <router-link to="/events#event-oct-4-2021">more...</router-link></p></li>
                <li><strong>4-6 October 2018</strong><p>Johannes Gutenberg-University Mainz: conference Music <router-link to="/events#event-oct-4-2018">more...</router-link></p></li>
                <li><strong>12 July 2018</strong><p>Project presentation at the 18th Biennial International <router-link to="/events#event-jul-12-2018">more...</router-link></p></li>
            </ul>
        </article>
        <article class="activities">
            <h3>Activities</h3>
            <ul>
              <!--<li><strong>31 December 2021</strong><p><router-link to="/events#event-sep-30-2021">more...</router-link></p></li>-->
              <li><strong>31 December 2021</strong><p>Publication of a thematic issue in Musicology Today (<a href="https://sciendo.com/issue/MUSO/18/1" target="_blank">https://sciendo.com/issue/MUSO/18/1</a>)</p></li>
                <li><strong>February/March 2021</strong><p>Publication: Operatic Pasticcios in 18th-Century Europe <router-link to="/events#act-mar-01-2021">more...</router-link></p></li>
                <li><strong>30 November 2020</strong><p>Paper at Università degli Studi della Basilicata <router-link to="/events#act-nov-30-2020">more...</router-link></p></li>
                <li><strong>21 November 2020</strong><p>Panel discussion at "Early Music in the Web age" <router-link to="/events#act-nov-21-2020">more...</router-link></p></li>
                <li><strong>25–26 October 2020</strong><p>Panel at 49. Musicological Conference of Polish Composers’ Union <router-link to="/events#act-oct-25-2020">more...</router-link></p></li>
                <li><strong>16–18 October 2020</strong><p>Paper at the conference "Financing Music in Europe" <router-link to="/events#act-oct-16-2020">more...</router-link></p></li>
                <li><strong>23–25 September 2020</strong><p>Paper at the conference "Patrons, Intermediaries <router-link to="/events#act-sep-23-2020">more...</router-link></p></li>
                <li><strong>25–27 March 2020</strong><p>Papers at the conference „ ‚Parole del Metastasio‘ <router-link to="/events#act-mar-25-2020">more...</router-link></p></li>
                <li><strong>18 March 2020</strong><p>Paper at Greifswald University: „Solo-Szenen in <router-link to="/events#act-mar-18-2020">more...</router-link></p></li>
                <li><strong>2–6 March 2020</strong><p>Paper at the DHd 2020 conference „Spielräume. Digital <router-link to="/events#act-mar-2-2020">more...</router-link></p></li>
                <li><strong>12–15 February 2020</strong><p>Plenum paper at the conference „Werk und Beiwerk. <router-link to="/events#act-feb-12-2020">more...</router-link></p></li>
                <li><strong>14 October 2019</strong><p>Semester opening lecture „Vivan pure i pasticcieri!" <router-link to="/events#act-oct-14-2019">more...</router-link></p></li>
                <li><strong>27–29 June 2019</strong><p>Paper at the conference "Musik und die Künste in der <router-link to="/events#act-jun-27-2019">more...</router-link></p></li>
                <li><strong>9–12 May 2019</strong><p>Three papers at the international Farinelli conference <router-link to="/events#act-may-12-2019">more...</router-link></p></li>
                <li><strong>9–11 May 2019</strong><p>Paper at the international conference WERKE, WERKTITEL, <router-link to="/events#act-may-10-2019">more...</router-link></p></li>
                <li><strong>9–11 May 2019</strong><p>Paper at the conference „Mapping Italian Theater. Knowledge <router-link to="/events#act-may-09-2019">more...</router-link></p></li>
                <li><strong>25–29 March 2019</strong><p>Panel at the 6th Annual Meeting of DHd (Digital <router-link to="/events#act-march-25-2019">more...</router-link></p></li>
                <li><strong>29–30 January 2019</strong><p>Paper at the conference Music, Performing Arts and <router-link to="/events#act-jan-29-2019">more...</router-link></p></li>
                <li><strong>17–18 December 2018</strong><p>Three papers at the international conference "Libretti d'opera <router-link to="/events#act-dec-17-2018">more...</router-link></p></li>
                <li><strong>3 December 2018</strong><p>Participation at GNDCON of Gesa zur Nieden and Daniel Röwenstrunk <router-link to="/events#act-dec-03-2018">more...</router-link></p></li>
                <li><strong>13 July 2018</strong><p>Paper at the 18th Biennial International Baroque Conference <router-link to="/events#act-jul-13-2018">more...</router-link></p></li>
                <li><strong>26, 28–29 May 2018</strong><p>Paper at the International Conference "Musikalische <router-link to="/events#act-may-26-2018">more...</router-link></p></li>
                <li><strong>19 May 2018</strong><p>Paper at the Symposium "Metropole London – Konflikte und <router-link to="/events#act-may-19-2018">more...</router-link></p></li>
                <li><strong>2 April 2018</strong><p>Interview with Aneta Markuszewska on Polish Radio 1 on the <router-link to="/events#act-apr-2-2018">more...</router-link></p></li>
            </ul>
        </article>
    </aside>
</template>

<script>
    export default {
        name: "News"
    }
</script>

<style scoped lang="css">
    .content-aside {
        width:240px;
        background:rgb(255,255,255);
        display:table-cell;
        vertical-align:top;
        font-family: 'Open Sans', sans-serif;
        font-weight:300;
        line-height:21px;
    }

    .content-aside h2 {
        font-family: 'Open Sans', sans-serif;
        font-weight:600;
        font-size:21px;
        line-height:30px;
        margin-bottom:22px;
    }
    .content-aside h3 {
        font-family: 'Open Sans', sans-serif;
        font-weight:600;
        font-size:18px;
        line-height:26px;
        margin-bottom:0;
    }
    .content-aside h4 {
        font-family: 'Open Sans', sans-serif;
        font-weight:600;
        font-size:16px;
        line-height:26px;
        margin-bottom:0;
        color:black;
    }

    .content-aside ul {
        margin-bottom:14px;
    }
    .content-aside li {
        list-style-position: inside;
        color:#930303;
        padding-bottom:12px;
    }
    .content-aside li strong,
    .content-aside li p {
        color:black;
    }

    @media only screen and (min-width: 1px) and (max-width: 1059px) {
        .content-aside {
            width:22.5vw;
        }
    }

    @media only screen and (min-width: 1px) and (max-width: 799px) {
        .content-aside {
            display:none;
            position:absolute;
            top:0;
            left:0;
            width:100%;
            padding:45px 4vw;
            background-color:rgba(255,255,255,0.95);
            box-sizing:border-box;
            -webkit-box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);
            box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);
        }
    }
</style>
